import { PASSING } from '../actions/passing';

const defaultState = {
  lesson: {},
};

export default (state = defaultState, { type, ...action }) => {
  switch (type) {
    case PASSING.LOAD_QUESTION_DONE:
      return { ...state, lesson: action.lesson };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/passing.js